import React from "react";
import plasterBoardImage from '../assets/plaster_board.jpeg';
import screedingImage from '../assets/screeding.jpeg';
import wallPartitionImage from '../assets/wall_partition.png';


const servicesData = [
  {
    image: plasterBoardImage,
    fallback: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ1bOrCEY90DxDKfg5Jf8go5ExltQk92I73fdW4-r2WdPD4LYkgBR8OQHl30EXBxePicV0&usqp=CAU",
    title: "Gypsum Plaster Board",
    description: "Stunning and intricate POP ceiling  designs that add elegance to any room.",
  },
  {
    image: '',
    fallback: "https://i.pinimg.com/236x/71/bf/ec/71bfec37d57ce1e53280283d52a93bf7.jpg",
    title: "Concrete Designs",
    description: "Stylish and durable concrete designs that add character to your spaces exterior and interior.",
  },
  {
    image: '',
    fallback: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ1bOrCEY90DxDKfg5Jf8go5ExltQk92I73fdW4-r2WdPD4LYkgBR8OQHl30EXBxePicV0&usqp=CAU",
    title: "POP Ceiling Designs and installations",
    description: "Stunning and intricate POP ceiling designs that add elegance to any room.",
  },
  {
    image: wallPartitionImage,
    fallback: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ1bOrCEY90DxDKfg5Jf8go5ExltQk92I73fdW4-r2WdPD4LYkgBR8OQHl30EXBxePicV0&usqp=CAU",
    title: "Dry Wall Partitioning",
    description: "Stunning and intricate POP ceiling designs that add elegance to any room.",
  },
  {
    image: screedingImage,
    fallback: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSPMdHii4UCUPJSfgJwF7fJZWwp2bbWExigGw&s",
    title: "Screeding, Consoles and Wall Finishes",
    description: "Stunning and intricate POP ceiling designs that add elegance to any room.",
  }
];

const Services = () => {
  // Use the same duplicated data trick for the infinite scroll
  const duplicatedData = [...servicesData, ...servicesData];

  return (
    <section className="py-16 bg-white text-slate-900 overflow-hidden dark:bg-slate-950 dark:text-gray-100">
      <div className="flex flex-col items-center justify-center mb-12">
        <h1 className="text-4xl font-bold mb-4">Our Services</h1>
        <div className="h-1.5 w-36 bg-orange-500 rounded-lg"></div>
      </div>

      {
        servicesData.length <= 6 ?
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:px-20 px-6">
          {servicesData.map((service, index) => (
            <div
              key={index}
              className="max-w-xs mx-auto p-6 bg-white border border-gray-200 rounded-lg shadow-md dark:bg-slate-900 dark:border-slate-700"
            >
              <img
                src={service.image} 
                onError={(e) => { e.target.src = service.fallback; }}
                alt={service.title}
                className="w-24 h-24 mx-auto rounded-full object-cover mb-6 border-4 border-orange-100"
              />
              <div className="text-center">
                <h2 className="text-xl font-bold mb-3">{service.title}</h2>
                <p className="text-gray-500 text-sm whitespace-normal">{service.description}</p>
              </div>
            </div>
          ))}
        </div>
        :
        <div className="animate-marquee flex">
          {duplicatedData.map((service, index) => (
            <div key={index} className="flex-shrink-0 w-[350px] mx-6 p-8 bg-white border rounded-2xl shadow-sm dark:bg-slate-900 dark:border-slate-700">
              <img
                src={service.image} 
                onError={(e) => { e.target.src = service.fallback; }}
                alt={service.title}
                className="w-24 h-24 mx-auto rounded-full object-cover mb-6 border-4 border-orange-100"
                loading="lazy"
              />
              <div className="text-center">
                <h2 className="text-xl font-bold mb-3">{service.title}</h2>
                <p className="text-gray-500 text-sm whitespace-normal">{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      }
    </section>
  );
};

export default Services;